<oe-flat-widget [title]="'GENERAL.LAST_MONTH_PRODUCTION' | translate" [icon]="{name: 'oe-production', color: 'production'}">
  <ng-container>
    <p class="signage-font-edge5card">{{getLastMonthProduction()}}</p>
  </ng-container>
</oe-flat-widget>
